import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import ReadMore from '../utils/ReadMore';
import { getOptions } from '../textBlock/TextBlockWithIcon';
import { withRouteData } from 'react-static';
import { getArtworkUrl } from '../utils/Contentful';

const Item = styled.div`
  position: relative;
  text-align: center;

  h2 {
    font-size: var(--fs-l);
    margin-top: 1rem;
    margin-bottom: 0;
  }

  .preview {
    font-size: var(--fs-focus);
  }

  img {
    width: 50%;

    ${media.mediumLarge`
      width: 100%;
    `}
  }
`;

const Role = styled.div`
  font-size: var(--fs-s);
  font-weight: 500;
  margin-top: 0.5rem;
  ${legacyType('s', 'label')};
`;

const Body = styled.div`
  font-size: var(--fs-sm);
  ${legacyType('sm', 'body')};
  margin-top: 2rem;

  a {
    text-decoration: underline;
  }
`;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--default-vertical-padding) 1rem;
  margin-left: auto;
  margin-right: auto;

  > :not(:last-child) {
    margin-bottom: 2rem;
  }

  ${media.mediumLarge`
    padding: var(--default-vertical-padding) 3rem;
  `}

  ${media.large`
    flex-direction: row;
    align-items: center;
    
    > :not(:last-child) {
      margin-bottom: 0;
      margin-right: 2rem;
    }
  `}

  img {
    width: 50%;

    ${media.large`
      width: unset;
    `}
  }
`;

const ModalText = styled.div`
  h1 {
    margin-bottom: 0;
  }
`;

const TeamItem = ({ content, openModal, basename }) => {
  const { name, role, image, description } = content;

  const modalComponent = () => {
    return (
      <ModalWrapper>
        {image && <img src={getArtworkUrl(image)} alt="" />}
        <ModalText>
          {name && <h1>{name}</h1>}
          {role && <Role>{role}</Role>}
          {description && (
            <Body>{documentToReactComponents(description, getOptions(basename))}</Body>
          )}
        </ModalText>
      </ModalWrapper>
    );
  };

  return (
    <Item>
      {description && (
        <button
          className="dummy-btn"
          onClick={() => openModal(modalComponent())}
          aria-label={name}
        />
      )}
      {image && <img src={getArtworkUrl(image)} alt="" />}
      {name && <h2>{name}</h2>}
      {role && <Role className="preview">{role}</Role>}
      {description && <ReadMore />}
    </Item>
  );
};

TeamItem.propTypes = {
  content: PropTypes.object,
  openModal: PropTypes.func,
  basename: PropTypes.string.isRequired,
};

export default withRouteData(TeamItem);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/team/TeamItem.js